import { AgNumberValueCellEditingRenderer } from 'components/AgGrid/AgNumberValueCellEditingRenderer';
import { useAccess } from 'hooks/useAccess';

import type { ICellRendererParams } from 'ag-grid-community';
import { useCallback, useMemo } from 'react';

import type { IBimContractResultPlanDataItem } from '../../../WorkOrder/types';

import Style from './ContractPlanCellRendererComponent.module.css';

interface IContractPlanCellRendererComponent extends ICellRendererParams {
    isReadOnly: boolean;
    onChange?: (id: string, value: number | null) => void;
    isProjectStatusDelayed?: boolean;
    constructionTypeId: number;
}

export const ContractPlanCellRendererComponent = (props: IContractPlanCellRendererComponent) => {
    const { isReadOnly, isProjectStatusDelayed, onChange, constructionTypeId, data, ...rest } = props;

    const { contractBim: contractBimRules } = useAccess();
    const { isEditable, id } = data as IBimContractResultPlanDataItem;

    const formCellId = useMemo(() => `contractPlan_${id}_${constructionTypeId}`, [constructionTypeId, id]);

    const onChangeLocal = useCallback(
        (value: number | null) => {
            onChange?.(formCellId, value);
        },
        [formCellId, onChange],
    );

    return (
        <div className={Style.contractPlanCellRenderer}>
            <AgNumberValueCellEditingRenderer
                data={data}
                decimalScale={2}
                isEditable={!isReadOnly && isEditable}
                idKey="id"
                columnKey={`contractPlan_${constructionTypeId}`}
                onChange={onChangeLocal}
                disabled={!contractBimRules.canCreate || isProjectStatusDelayed}
                {...rest}
            />
        </div>
    );
};

ContractPlanCellRendererComponent.displayName = 'ContractPlanCellRendererComponent';
